module.exports = __webpack_public_path__ + "static/media/Associated Equipment Distributors Logo-300x110.d9c30a4e.jpg";